// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
  register: path(ROOTS_AUTH, "/register"),
  loginUnprotected: path(ROOTS_AUTH, "/login-unprotected"),
  registerUnprotected: path(ROOTS_AUTH, "/register-unprotected"),
  verify: path(ROOTS_AUTH, "/verify"),
  resetPassword: path(ROOTS_AUTH, "/reset-password"),
};

export const PATH_PAGE = {
  comingSoon: "/coming-soon",
  maintenance: "/maintenance",
  pricing: "/pricing",
  payment: "/payment",
  about: "/about-us",
  contact: "/contact-us",
  faqs: "/faqs",
  page404: "/404",
  page500: "/500",
  components: "/components",
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, "/app"),
    tickets: path(ROOTS_DASHBOARD, "/tickets"),
    raisedTicket: path(ROOTS_DASHBOARD, "/raised-ticket"),
    studentSizing: path(ROOTS_DASHBOARD, "/student-sizing"),
    orderPromotion: path(ROOTS_DASHBOARD, "/variation-bulk"),
  },
  master: {
    root: path(ROOTS_DASHBOARD, "/master"),
    category: path(ROOTS_DASHBOARD, "/master/category"),
    package: path(ROOTS_DASHBOARD, "/master/package"),
    product: path(ROOTS_DASHBOARD, "/master/product"),
    ticketCategory: path(ROOTS_DASHBOARD, "/master/ticket-category"),
  },
  reports: {
    root: path(ROOTS_DASHBOARD, "/reports"),
    newReport: path(ROOTS_DASHBOARD, "/reports/new-report"),
    newAndPending: path(ROOTS_DASHBOARD, "/reports/new-and-pending-report"),
    studentwisependingReport: path(ROOTS_DASHBOARD, "/reports/student-wise-pending-report"),
    schoolwisependingReport: path(ROOTS_DASHBOARD, "/reports/school-wise-pending-report"),
    dateWiseReport: path(ROOTS_DASHBOARD, "/reports/date-wise-report"),
    orderWiseGSTReport: path(ROOTS_DASHBOARD, "/reports/order-wise-gst-report"),
    salesWithGst: path(ROOTS_DASHBOARD, "/reports/sale-with-gst"),
    salesWithOutGst: path(ROOTS_DASHBOARD, "/reports/sale-without-gst-report"),
    shippingReport: path(ROOTS_DASHBOARD, "/reports/shipping-wise-report"),
    salesReport: path(ROOTS_DASHBOARD, "/reports/sales-report"),
    settlementReport: path(ROOTS_DASHBOARD, "/reports/settlement-report"),
  },
};
